import { AxiosRequestConfig } from "axios";
import {
  CompaniesList,
  CompaniesListResponseSchema,
  getCompanyEndpoint,
  http,
} from "@/services";

export const requestCompaniesList = (
  { email }: { email: string },
  config?: AxiosRequestConfig,
) =>
  http.get<CompaniesList>(
    getCompanyEndpoint,
    { email },
    config,
    undefined,
    CompaniesListResponseSchema,
  );
